<template>
  <HeaderNav :mobile="mobile" :mobileNav="mobileNav" :toggleSidebar="toggleSidebar" />
  <router-view class="site-content" :mobile="mobile" />
  <FooterBlock />
</template>

<script>
// @ is an alias to /src
import HeaderNav from '@/components/HeaderNav.vue'
import FooterBlock from '@/components/FooterBlock.vue'

export default {
  name: 'App',
  components: {
    HeaderNav, FooterBlock
  },
  data() {
    return {
      mobile: false,
      mobileNav: false
    }
  },
  created() {
    window.addEventListener("resize", this.checkScreen)
    this.checkScreen()
  },
  methods: {
    checkScreen() {
      if (window.innerWidth <= 768) {
        this.mobile = true
        return
      }
      this.mobile = false
      this.mobileNav = false
      return
    },
    toggleSidebar() {
      this.mobileNav = !this.mobileNav
    }
  },
  // Scroll to the top whenever the route changes
  watch: {
    $route(to, from) {
      window.scrollTo(0, 0)
    }
  },
}
</script>

<style>
body {
  margin: 0;
}

@font-face {
  font-family: "Retro-Computer";
  src: url('@/assets/fonts/retro_computer_personal_use.ttf');
}

@font-face {
  font-family: "Justice";
  src: url('@/assets/fonts/justice.ttf');
}

@font-face {
  font-family: "Atkinson-Hyperlegible";
  src: url('@/assets/fonts/AtkinsonHyperlegible-Bold.ttf')
}

:root {
  --bg: #000A00;
  --dGreen: #002F00;
  --green: #004A00;
  --lGreen: #00FF88;
  --red: #EC1935;
  color: white;
  background: var(--bg);
}

.site-content {
  max-width: 1366px;
  margin: auto auto 2em;
}

img {
  max-width: 100%;
}

h2,
summary {
  font-family: "Justice";
  text-transform: uppercase;
  font-size: 32px;
}

h1,
h2,
h3,
summary {
  width: max-content;
}

h3 {
  font-size: 24px;
}

h1 {
  font-size: 40px;
}

ol,
ul {
  font-size: 20px;
}

details {
  margin: 50px;
}

p,
a,
li,
div,
h1,
button,
input {
  font-family: "Retro-Computer";
  color: white;
}

p,
a,
button,
input {
  font-size: 20px;
}

/* Longer texts having a more readable font than retro-computer */
details p,
details li,
article * {
  /* font-family: Arial, Helvetica, sans-serif; */
  /* font-family: 'Courier New', Courier, monospace; */
  /* font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif; */
  /* font-family: 'Times New Roman', Times, serif; */
  /* font-family: Verdana, Geneva, Tahoma, sans-serif; */
  /* font-family: "Press Start 2P"; */
  /* font-size: 16px; */
  font-family: "Atkinson-Hyperlegible";
  font-size: 22px;
}

a {
  text-decoration: none;
}

.site-content nav {
  border: 2px solid var(--lGreen);
  max-width: 666px;
}

ol {
  margin: 8px;
}

ol li {
  padding: 8px;
}

ul,
li a {
  padding: 0;
}

ul li {
  margin: 8px 32px;
}

ol li:hover>a,
ol li:hover,
ul li:hover,
ul li:hover>a {
  color: var(--lGreen);
  cursor: pointer;
}

i {
  color: grey;
}

button {
  background: none;
  border: 2px solid var(--lGreen);
  padding: 10px;
  margin: 20px 0;
  transition: all .1s;
  cursor: pointer;
}

button:active,
button:disabled,
button.downloading {
  border: 2px solid white;
  color: var(--lGreen);
  text-shadow: 4px 4px var(--red);
}

button:hover:not(:disabled) {
  transform: scale(1.1);
}

/* Loading animation */
button.downloading {
  position: relative;
  /* space for spinner */
  padding-right: 40px;
  transform: scale(1.1);
  margin-right: 10px;
}

button.downloading::before {
  content: '';
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  border: 2px solid white;
  border-top-color: var(--lGreen);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: translateY(-50%) rotate(360deg);
  }
}

/* Optional: whole page cursor during download */
.downloading {
  cursor: wait;
}

.screenshot-grid {
  display: grid;
  grid-template-columns: auto auto auto;
  gap: 10px 15px
}

.underline {
  text-decoration: underline;
}

.animText {
  color: var(--lGreen);
  text-shadow: 4px 4px var(--red);
  animation: hlmTextRotate 8s infinite, hlmTextShadow 5s linear infinite;
}

details p {
  color: var(--lGreen);
  cursor: default;
}

details details summary {
  font-size: 28px;
}

details img,
details p,
details ul {
  margin-left: 30px;
}

/* mobile rules */
@media(max-width:786px) {

  h1,
  h2,
  h3 {
    text-align: center;
  }

  details {
    margin: 50px auto;
    width: 90%;
  }

  .screenshot-grid {
    display: flex;
    overflow: auto;
    gap: 0 8px;
  }

  .screenshot-grid img {
    max-width: 40%;
  }

  h1,
  h2,
  h3,
  summary {
    width: initial;
  }

  .site-content nav {
    margin: 0 8px;
  }

  button {
    margin: 20px 8px;
  }

  article {
    padding: 0 10px;
  }

  p,
  button,
  a,
  ol,
  ul {
    font-size: 16px;
  }

  h2,
  summary {
    font-size: 26px;
  }

  h1 {
    font-size: 32px;
  }

  details p,
  details li,
  article * {
    font-size: 18px;
  }

  details img,
  details p,
  details ul {
    margin-left: 0px;
  }

}

@keyframes hlmTextShadow {
  from {
    text-shadow: 4px 4px var(--red);
  }

  25% {
    text-shadow: 4px -4px var(--red);
  }

  50% {
    text-shadow: -4px -4px var(--red);
  }

  75% {
    text-shadow: -4px 4px var(--red);
  }

  to {
    text-shadow: 4px 4px var(--red);
  }
}

@keyframes hlmTextRotate {
  from {
    transform: rotate(0deg);
    animation-timing-function: ease-out;
    transform-origin: 50% 50%;
  }

  25% {
    transform: rotate(2deg);
    animation-timing-function: ease-in;
    transform-origin: 50% 50%;
  }

  50% {
    transform: rotate(0deg);
    animation-timing-function: ease-out;
    transform-origin: 50% 50%;
  }

  75% {
    transform: rotate(-2deg);
    animation-timing-function: ease-in;
    transform-origin: 50% 50%;
  }

  to {
    transform: rotate(0deg);
    animation-timing-function: ease-out;
    transform-origin: 50% 50%;
  }
}
</style>
